import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { AnalyticalPanel, DataQualityState, SourceLabel } from '@atlas/ui';
import { api } from '../../lib/api';
import { ExplainActions, PageHeader } from '../../components/shared';
import { PageSkeleton } from '../../components/PageSkeleton';

export function LibraryPage() {
  const [q, setQ] = useState('hormuz');
  const { data, isLoading, isError } = useQuery({
    queryKey: ['library', q],
    queryFn: () => api.library(q),
  });

  if (isLoading) return <PageSkeleton blocks={2} />;
  if (isError) return <DataQualityState state="unavailable" title="Library search unavailable" />;

  const results = data?.results ?? [];

  return (
    <div className="space-y-6">
      <PageHeader title="Library" subtitle="Articles, tweets, filings, and cited claims." />
      <ExplainActions screenName="Library" />

      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        className="w-full max-w-md rounded-[var(--radius-control)] border border-[var(--color-border-strong)] bg-[var(--color-surface-1)] px-3 py-2 text-sm"
        aria-label="Search library"
        placeholder="Search sources…"
      />

      <AnalyticalPanel title="Search results">
        <ul className="space-y-3">
          {results.map((r) => (
            <li key={r.sourceId} className="flex items-center justify-between gap-4 border-b border-[var(--color-border-default)] pb-3 text-sm last:border-0">
              <div>
                <p className="text-[var(--color-text-primary)]">{r.title}</p>
                <p className="text-xs text-[var(--color-text-muted)]">{r.sourceType}</p>
              </div>
              <SourceLabel source={r.sourceId} tier={r.trustTier === 1 ? 'primary' : 'corpus'} />
            </li>
          ))}
          {results.length === 0 && <DataQualityState state="empty" title="No results" />}
        </ul>
      </AnalyticalPanel>
    </div>
  );
}
